import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

import { useAuthStore } from "../stores/auth";

/**
 * This component syncs the subscription tier on every route change
 * It ensures the correct tier is always displayed throughout the app
 */
export const SubscriptionTierSync = () => {
  const location = useLocation();
  const { user, syncSubscriptionTier } = useAuthStore();
  const lastUserRef = useRef(user);
  const lastLoginTimeRef = useRef<number>(0);

  // Sync on route change and on mount
  useEffect(() => {
    syncSubscriptionTier();
  }, [location.pathname, syncSubscriptionTier]);

  // Detect login state change and sync immediately
  useEffect(() => {
    const currentTime = Date.now();
    const wasLoggedOut = !lastUserRef.current;
    const isNowLoggedIn = !!user;

    if (wasLoggedOut && isNowLoggedIn) {
      lastLoginTimeRef.current = currentTime;

      // Sync immediately and again after a short delay to ensure consistency
      syncSubscriptionTier();
      setTimeout(() => {
        syncSubscriptionTier();
      }, 500);

      // Additional sync after 2 seconds to catch any delayed updates
      setTimeout(() => {
        syncSubscriptionTier();
      }, 2000);
    }

    // Update the ref for next comparison
    lastUserRef.current = user;
  }, [user, syncSubscriptionTier]);

  // Periodic sync every 30 seconds if user is logged in
  useEffect(() => {
    if (!user) return;

    const interval = setInterval(() => {
      syncSubscriptionTier();
    }, 30_000);

    return () => {
      clearInterval(interval);
    };
  }, [user, syncSubscriptionTier]);

  return null; // This is a utility component that doesn't render anything
};
